import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Hammer from 'hammerjs';
import './pitch.css';

const Icon = ({ pitch }) => (
  <svg
    fill="#000000"
    viewBox="0 0 24 24"
    style={{ transform: `rotate(${pitch - 90}deg)` }}
  >
    <path d="M22 12l-4-4v3H3v2h15v3z" />
  </svg>
);

Icon.propTypes = {
  pitch: PropTypes.number.isRequired,
};

class PitchControl extends Component {
  static contextTypes = {
    map: PropTypes.object.isRequired,
  };

  state = {
    pitch: 0,
  }

  componentWillMount() {
    const { map } = this.context;

    this.mc = new Hammer.Manager(map.getContainer());

    const horizontal = new Hammer.Pan({
      direction: Hammer.DIRECTION_HORIZONTAL,
      threshold: 50,
      pointers: 2,
    });

    const vertical = new Hammer.Pan({
      event: 'panv',
      direction: Hammer.DIRECTION_VERTICAL,
      pointers: 2,
    });

    vertical.requireFailure(horizontal);

    this.mc.add([vertical, horizontal]);

    this.mc.on('panvstart', this.onPanStart);
    this.mc.on('panv', this.onPan);
    map.on('pitch', this.onPitch);
    this.setState({ pitch: map.getPitch() });
  }

  componentWillUnmount() {
    this.mc.off('panvstart', this.onPanStart);
    this.mc.off('panv', this.onPan);
    this.context.map.off('pitch', this.onPitch);
  }

  onPitch = () => {
    this.setState({ pitch: this.context.map.getPitch() });
  }

  onPanStart = ({ deltaY }) => {
    this.pitch = this.context.map.getPitch() + (deltaY / 2);
  }

  onPan = ({ deltaY }) => {
    this.context.map.setPitch(this.pitch - (deltaY / 2));
  }

  resetPitch = () => {
    this.context.map.easeTo({ pitch: 0 });
  }

  render() {
    return (
      <div className="pitch-control">
        <button onClick={this.resetPitch} className="pitch-control--button">
          <span className="pitch-control--icon">
            <Icon pitch={this.state.pitch} />
          </span>
        </button>
      </div>
    );
  }
}

export default PitchControl;



// WEBPACK FOOTER //
// ./src/controls/pitch.js